module.exports = __webpack_public_path__ + "static/media/ioic_app_login_h.d07f7a81.jpg";